import "@babel/polyfill";
import Vue from "vue";
import Vuetify, { VLayout } from "vuetify/lib";
import { VuetifyUseOptions } from "vuetify";
import "vuetify/src/stylus/app.styl";
import nl from "vuetify/src/locale/nl";
import "../../fontawesome/js/all.js";

export default (config: VuetifyUseOptions): void => {
  config = {
    ...{
      components: { VLayout },
      customProperties: true,
      lang: {
        locales: { nl },
        current: "nl",
      },
    },
    ...config,
  };

  Vue.use(Vuetify, config);
};
